class SqualoSwipeGallery {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.squalo-swipe-gallery__track');
    this.dots = Array.from(el.querySelectorAll('.squalo-swipe-gallery__dot'));
    this.slideCount = el.querySelectorAll('.squalo-swipe-gallery__slide').length;
    if (this.track && this.slideCount > 1) this.bind();
  }

  bind() {
    // Update active dot as user scrolls
    this.track.addEventListener('scroll', () => {
      const index = Math.round(this.track.scrollLeft / this.track.offsetWidth);
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }, { passive: true });

    // Tap a dot to jump to that slide
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        this.track.scrollTo({ left: i * this.track.offsetWidth, behavior: 'smooth' });
      });
    });

    // Desktop with hover: show second image on mouseenter, reset on mouseleave
    const cardWrapper = this.el.closest('.squalo-card-wrapper');
    if (cardWrapper && window.matchMedia('(hover: hover)').matches) {
      cardWrapper.addEventListener('mouseenter', () => {
        if (this.track.scrollLeft === 0) {
          this.track.scrollTo({ left: this.track.offsetWidth, behavior: 'smooth' });
        }
      });
      cardWrapper.addEventListener('mouseleave', () => {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      });
    }
  }
}

function initSqualoGalleries() {
  document.querySelectorAll('.squalo-swipe-gallery').forEach(el => {
    if (!el.dataset.squaloInit) {
      el.dataset.squaloInit = '1';
      new SqualoSwipeGallery(el);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSqualoGalleries);
} else {
  initSqualoGalleries();
}

function initProductPageDots() {
  if (window.innerWidth > 749) return;

  const mediaList = document.querySelector('.product--stacked .product__media-list');
  if (!mediaList) return;

  const slides = Array.from(mediaList.querySelectorAll('.product__media-item'));
  if (slides.length <= 1) return;

  const dotsContainer = document.createElement('div');
  dotsContainer.className = 'squalo-product-dots';

  slides.forEach((_, i) => {
    const dot = document.createElement('span');
    dot.className = 'squalo-product-dot' + (i === 0 ? ' is-active' : '');
    dotsContainer.appendChild(dot);
  });

  mediaList.parentNode.insertBefore(dotsContainer, mediaList.nextSibling);

  const dots = Array.from(dotsContainer.querySelectorAll('.squalo-product-dot'));

  mediaList.addEventListener('scroll', () => {
    const index = Math.round(mediaList.scrollLeft / mediaList.offsetWidth);
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }, { passive: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductPageDots);
} else {
  initProductPageDots();
}

// Re-init galleries when product-recommendations loads its content via AJAX
document.querySelectorAll('product-recommendations').forEach(el => {
  new MutationObserver(() => initSqualoGalleries()).observe(el, { childList: true, subtree: true });
});

